// The restaurant this browser last worked in.
//
// Key export: `readSavedActiveTeamId`.
// Neighbours: `state/useTeam.ts` (writes the key when a restaurant is selected or a support session
// opens), `shell/AuthGate.tsx` (reopens it for a support or admin agent after a reload).
//
// A reload forgets the live selection but not this id. Storage can be blocked, so a read that fails
// answers null.

const LS_ACTIVE_TEAM = 'synvya_active_team_id'

export function readSavedActiveTeamId(): number | null {
  try {
    const n = Number(localStorage.getItem(LS_ACTIVE_TEAM))
    return Number.isInteger(n) && n > 0 ? n : null
  } catch {
    return null
  }
}
